import { ColumnDef } from "@tanstack/react-table";
import { useLanguage } from "hooks";
import {
  TransactionItem,
  TRANSACTIONS_STATUSES_LIST,
  useTransactions
} from "modules/financial";
import moment from "moment";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable, TableItemStatus } from "ui";

import { StatisticsBlockLayout } from "../../layouts";

import styles from "../../styles/TableStyles.module.scss";

const RecentTransactions = () => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const { transactions, isLoading } = useTransactions({ page: 1, take: 5 });

  const columns: Array<ColumnDef<TransactionItem, TransactionItem[]>> = useMemo(
    () => [
      {
        id: "id",
        header: t("Transaction"),
        enableSorting: false,
        size: 100,
        minSize: 100,
        cell: ({ row }) => (
          <>
            <p className={styles["statistics__table--id"]}>
              {transactions[row.index].id}
            </p>
            <p className={styles["statistics__table--user"]}>
              {`${transactions[row.index].reseller.firstname} ${transactions[row.index].reseller.lastname}`}
            </p>
          </>
        )
      },
      {
        id: "amount",
        header: t("Total (FCFA)"),
        enableSorting: false,
        size: 1,
        minSize: 1,
        cell: ({ row }) =>
          transactions[row.index].amount.toLocaleString("en-US")
      },
      {
        id: "createdAt",
        header: t("Date & Time"),
        size: 1,
        minSize: 1,
        cell: ({ row }) => (
          <pre>
            {`${moment(transactions[row.index].createdAt).format("DD/MM/YYYY")}`}
            {"\n"}
            {`${moment(transactions[row.index].createdAt).format("HH:mm")}`}
          </pre>
        )
      },
      {
        id: "status",
        header: t("Status"),
        enableSorting: false,
        size: 1,
        minSize: 1,
        cell: ({ row }) => (
          <TableItemStatus
            className={styles["statistics__table--status"]}
            statusesList={TRANSACTIONS_STATUSES_LIST}
            activeStatusIndex={TRANSACTIONS_STATUSES_LIST.findIndex(
              (statusItem) =>
                statusItem?.value === transactions[row.index].status
            )}
          />
        )
      }
    ],
    [transactions, t, currentLanguage]
  );

  return (
    <StatisticsBlockLayout
      title="Recent Transactions"
      navigationPass="/transactions"
    >
      <ItemsTable
        columns={columns}
        data={transactions ?? []}
        isLoading={isLoading}
        className={styles.statistics__table}
      />
    </StatisticsBlockLayout>
  );
};

export default RecentTransactions;
